const MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

const isLeap = (year: number) => (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
const daysIn = (year: number, month: number) =>
  [31, isLeap(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month - 1];

/**
 * moment(text, ['DD/MM/YYYY','D/M/YYYY','DD-MM-YYYY','D-M-YYYY','YYYY-MM-DD','DD MMM YYYY','D MMM YYYY'], true), which the
 * company contact dialog used. Strict mode: two digits for DD/MM, one or two without a leading zero for D/M, four for
 * YYYY, an English three-letter month for MMM (any case) and a real calendar date.
 */
const PATTERNS: { re: RegExp; order: 'dmy' | 'ymd' | 'dMy' }[] = [
  { re: /^(\d{2})\/(\d{2})\/(\d{4})$/, order: 'dmy' },
  { re: /^([1-9]\d?)\/([1-9]\d?)\/(\d{4})$/, order: 'dmy' },
  { re: /^(\d{2})-(\d{2})-(\d{4})$/, order: 'dmy' },
  { re: /^([1-9]\d?)-([1-9]\d?)-(\d{4})$/, order: 'dmy' },
  { re: /^(\d{4})-(\d{2})-(\d{2})$/, order: 'ymd' },
  { re: /^(\d{2}) ([A-Za-z]{3}) (\d{4})$/, order: 'dMy' },
  { re: /^([1-9]\d?) ([A-Za-z]{3}) (\d{4})$/, order: 'dMy' },
];

/** Returns yyyy-MM-dd, null when blank, or undefined when the text is not a date. */
export function parseContactDate(value: string | null | undefined): string | null | undefined {
  const text = (value ?? '').trim();
  if (!text) return null;
  for (const { re, order } of PATTERNS) {
    const match = re.exec(text);
    if (!match) continue;
    let day: number;
    let month: number;
    let year: number;
    if (order === 'ymd') {
      year = +match[1];
      month = +match[2];
      day = +match[3];
    } else {
      day = +match[1];
      month = order === 'dMy' ? MONTHS.indexOf(match[2].toLowerCase()) + 1 : +match[2];
      year = +match[3];
    }
    if (month < 1 || month > 12 || day < 1 || day > daysIn(year, month)) continue;
    return `${`${year}`.padStart(4, '0')}-${`${month}`.padStart(2, '0')}-${`${day}`.padStart(2, '0')}`;
  }
  return undefined;
}
